<!-- Общие поля перехода статуса

Проверяет комментарий и фактическую дату, возвращает данные без привязки к API
-->
<template>
  <form :id="formId" @submit.prevent="submit">
    <BaseFormField
      v-if="withOccurredAt"
      :label="dateLabel"
      :for-id="`${formId}-occurred-at`"
      required
      :filled="Boolean(occurredAt)"
      :error="submitted && invalidDate"
      error-message="Укажите дату и время не позднее текущего момента"
    >
      <BaseInput
        :id="`${formId}-occurred-at`"
        v-model="occurredAt"
        type="datetime-local"
      />
    </BaseFormField>
    <BaseFormField
      :label="commentLabel"
      :for-id="`${formId}-comment`"
      :required="true"
      :filled="Boolean(comment.trim())"
      :error="submitted && !comment.trim()"
    >
      <base-textarea
        :id="`${formId}-comment`"
        v-model="comment"
        :placeholder="commentPlaceholder"
        rows="4"
      />
    </BaseFormField>
    <slot />
  </form>
</template>
<script>
import { formatDateTimeLocal } from "@/utils/dateUtils";
export default {
  name: "RecordListStatusTransitionForm",
  props: {
    formId: { type: String, required: true },
    withOccurredAt: { type: Boolean, default: false },
    dateLabel: { type: String, default: "Когда произошло изменение" },
    commentLabel: { type: String, default: "Причина" },
    commentPlaceholder: { type: String, default: "Коротко поясните изменение статуса" },
    isSubmitting: { type: Boolean, default: false },
  },
  emits: ["submit"],
  data() {
    return {
      comment: "",
      occurredAt: formatDateTimeLocal(new Date().toISOString()),
      submitted: false,
    };
  },
  computed: {
    invalidDate() {
      const date = new Date(this.occurredAt);
      return (
        !this.occurredAt ||
        !Number.isFinite(date.getTime()) ||
        date > new Date()
      );
    },
  },
  methods: {
    submit() {
      if (this.isSubmitting) return;
      this.submitted = true;
      if (
        (this.withOccurredAt && this.invalidDate) ||
        !this.comment.trim()
      )
        return;
      this.$emit("submit", {
        comment: this.comment.trim(),
        occurred_at:
          this.withOccurredAt
            ? new Date(this.occurredAt).toISOString()
            : null,
      });
    },
  },
};
</script>
